// extracted by mini-css-extract-plugin
export default {"post_button":"post-comment_post_button__4T2+z"};